// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4876":"62252f7f65229eaf","5129":"c7a5fdb053b4c1fd"}[chunkId] + ".css";
};